import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { BusIcon, ArrowRightIcon, UserIcon } from "assets/icons";
import {
  setBusDetail,
  setOpenTicketDetail,
  setTicketActiveStep,
} from "../redux/reducers/bookingReducer";

function TicketCard({ data, tripDate }) {
  const dispatch = useDispatch();
  const { openTicketDetail } = useSelector((state) => state.bookingReducer);

  let bus_img = `${process.env.REACT_APP_BASE_URL}/${data.bus_img}`;
  const filledSeats = data.totl_seat - data.left_seat;
  const filledPercentage = (filledSeats / data.totl_seat) * 100;

  useEffect(() => {
    if (openTicketDetail) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    document.body.addEventListener("click", () => {
      dispatch(setOpenTicketDetail(false));
    });
  }, [openTicketDetail]);

  return (
    <>
      <div className="w-full bg-white shadow-cityCard py-6 px-4 rounded-[12px] flex gap-8">
        <div className="hidden lg:flex flex-col">
          <img src={bus_img} alt="bus image" className="h-[40px]" />
        </div>
        <div className="w-full flex flex-col gap-4">
          <div className="w-full flex items-center justify-between gap-2 lg:hidden">
            <img src={bus_img} alt="bus image" className="h-[40px]" />
            <div className="text-lg lg:text-2xl text-[#191F26] font-semibold">
              MYR 20
            </div>
          </div>
          <div className="w-full flex items-center">
            <div className="flex-1 flex items-center gap-4">
              <span className="text-primary-700">
                <BusIcon />
              </span>
              <div className="flex-1 flex gap-2">
                <div className="text-base font-semibold text-[#263238]">
                  {data.boarding_city}
                </div>
                <div className="h-[18px] w-[18px] text-[#858585] mt-1">
                  <ArrowRightIcon />
                </div>
                <div className="flex flex-col">
                  <div className="text-base font-semibold text-[#263238]">
                    {data.drop_city}
                  </div>
                </div>
              </div>
            </div>
            {tripDate && (
              <div className="text-2xl text-[#191F26] font-semibold hidden lg:block">
                {moment(tripDate).format("DD MMM YYYY")}
              </div>
            )}
          </div>
          <div className="w-full flex items-center gap-4">
            <span className="text-primary-700">
              <UserIcon />
            </span>
            {/* Progress bar */}
            <div className="flex flex-col">
              <div className="text-[12px] sm:text-base text-[#63767E] font-medium mb-1">
                {` Available Seats - ${data.left_seat}`}
              </div>
              <div className="w-full max-w-[146px] h-[3px] rounded-[5px] bg-[#D9D9D9] relative overflow-hidden">
                <div
                  className={`h-full bg-primary-700`}
                  style={{ width: `${filledPercentage}%` }}
                />
              </div>
            </div>
          </div>
          <div className="w-full flex items-center">
            <div className="flex-1 flex flex-col gap-0.5">
              <div className="text-[12px] sm:text-base text-[#112211] font-medium">{`${data.bus_picktime} - ${data.bus_droptime}`}</div>
              <div className="text-[12px] sm:text-base text-[#112211]/40 font-medium">
                {data.bus_no}
              </div>
            </div>
            <div className="flex flex-col gap-0.5">
              <div className="min-w-[40px] max-w-fit h-[21] bg-primary-700 flex items-center justify-center text-[12px] sm:text-sm font-medium text-white">
                {data.bus_rate}
              </div>
              <div className="text-[12px] leading-4 sm:text-base text-[#112211] font-medium">
                {data.total_review} reviews
              </div>
            </div>
          </div>
          <div className="w-full flex items-center flex-wrap gap-3">
            {data.bus_facilities.map((item, index) => (
              <div
                key={index}
                className="hidden md:block w-full max-w-fit bg-[#F9EDE2] p-2 rounded-[5px] text-[12px] text-black font-semibold"
              >
                {item.facilityname}
              </div>
            ))}
          </div>
          <div className="w-full flex items-center">
            <button
              onClick={(e) => {
                e.stopPropagation();
                dispatch(
                  setBusDetail({
                    trip_date: tripDate,
                    ...data,
                  })
                );
                dispatch(setTicketActiveStep(1));
                dispatch(setOpenTicketDetail(true));
              }}
              className="w-full h-[48px] rounded-[4px] bg-primary-700 text-white text-sm font-semibold"
            >
              Select Seat
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default TicketCard;
